module.exports = __webpack_public_path__ + "media/stylesheets/images/pdf/FreeSpark第5期_貸借対照表_202205-33f2ffffd3b198c93bd5bbb4540944cd.pdf";